if (typeof window['global'] === 'undefined') {
  window['global'] = window;
}